module.exports = __webpack_public_path__ + "img/11.c22accb9.png";